import { A } from '#app/components/typography/a'
import { H1 } from '#app/components/typography/h1.tsx'
import { H2 } from '#app/components/typography/h2.tsx'
import { P } from '#app/components/typography/p.tsx'
import { Ul } from '#app/components/typography/ul'

export default function ButtonsRoute() {
	return (
		<>
			<H1>Buttons</H1>
			<P className="text-lg">Buttons allow users to perform actions with mouse, touch, or keyboard.</P>

			<H2>Deceptively complicated</H2>
			<P>Buttons seems like simple components at first, but they are incredibly complicated. Read the following articles to understand why:</P>
			<Ul>
				<li>
					<A href="https://react-spectrum.adobe.com/blog/building-a-button-part-1.html" target="_blank" rel="noreferrer">
						Building a Button Part 1: Press Events
					</A>
				</li>
				<li>
					<A href="https://react-spectrum.adobe.com/blog/building-a-button-part-2.html" target="_blank" rel="noreferrer">
						Building a Button Part 2: Hover Interactions
					</A>
				</li>
				<li>
					<A href="https://react-spectrum.adobe.com/blog/building-a-button-part-3.html" target="_blank" rel="noreferrer">
						Building a Button Part 3: Keyboard Focus Behavior
					</A>
				</li>
			</Ul>
		</>
	)
}
